export default {
   sites: [],
   getSitesInProgress: true,
   totalSites: 0,
   currentSite: {},
   errors: {},
   token: '',
};
